import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';

import RichText from '@/app/components/RichText';

import type { ProductBreakthroughItemsProps } from './ProductBreakthroughItems';
import ProductBreakthroughItems from './ProductBreakthroughItems';

const italicizeChunks = (chunks: React.ReactNode) => {
  return <em className="font-serif italic">{chunks}</em>;
};

const ProductBreakthrough = ({ shopButton }: ProductBreakthroughItemsProps) => {
  return (
    <section
      style={{
        background:
          'linear-gradient(72.18deg, #000000 29.6%, #0C1017 48.75%, #11161E 57.55%, #131820 67.78%, #141A22 75.86%, #151B23 83.24%, #151A23 95.85%)',
      }}
      className="py-32 text-white"
      data-cy="product-breakthrough"
    >
      <LayoutGrid rowGap={32}>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Typography
            color="inherit"
            variant="h2"
            Element="h2"
            align="center"
          >
            <RichText
              messageKey="pdp_horizon_breakthrough_title"
              tValues={{
                i: italicizeChunks,
              }}
            />
          </Typography>

          <Typography
            color="inherit"
            align="center"
            className="mx-auto mt-6 max-w-xl"
          >
            <RichText messageKey="pdp_horizon_breakthrough_subtitle" />
          </Typography>
        </GridItem>

        <ProductBreakthroughItems shopButton={shopButton} />
      </LayoutGrid>
    </section>
  );
};

export default ProductBreakthrough;
